<!-- 单位信息 未使用到-->
<template>
  <div class='company-info pad-side20'>
    <ProgressBar progress="20" />
    <CustomFormItem name="雇佣类型" placeholder="请选择雇佣类型" disabled v-model="pickerResult.employmentType" @click.native="showPicker('employmentType')" />
    <CustomFormItem name="单位名称" placeholder="请输入单位名称" v-model="freeLoanData.comName" />
    <CustomFormItem name="任职部门" placeholder="请输入任职部门" v-model="freeLoanData.department" />
    <CustomFormItem name="职位" placeholder="请输入职务/职位" v-model="freeLoanData.position" />
    <CustomFormItem name="入职时间" placeholder="请选择入职时间" disabled v-model="freeLoanData.yearsOfWork" @click.native="showPicker('yearsOfWork')" />
    <CustomFormItem name="单位地址" placeholder="请选择单位地址" disabled v-model="pickerResult.region" @click.native="showPicker('regionPicker')" />
    <CustomFormItem name="详细地址" placeholder="请输入详细地址" v-model="freeLoanData.comAdd" />
    <CustomFormItem name="单位电话" placeholder="请输入单位电话" v-model="freeLoanData.comTel"/>
    <div class="btn-wrap flex justify-content-center margin-b10">
      <input type="button" value="下一步" class="lg-btn" @click="nextStep">
    </div>
    <DefaultPicker ref="employmentType" :columns="employmentTypeColumns" @onConfirm="onPickerConfirm('employmentType', $event)" />
    <DefaultPicker ref="yearsOfWork" :columns="yearsOfWorkColumns" @onConfirm="onPickerConfirm('yearsOfWork', $event)" />
    <AreaPicker ref="regionPicker" @onConfirm="getRegionPickerVal"/>
  </div>
</template>

<script>
import CustomFormItem from "@/components/CustomFormItem.vue";
import ProgressBar from "@/components/ProgressBar";
import DefaultPicker from "@/components/DefaultPicker";
import AreaPicker from "@/components/AreaPicker";
import { mapState } from "vuex";

export default {
  name: 'CompanyInfo',

  components: {
    CustomFormItem,
    ProgressBar,
    DefaultPicker,
    AreaPicker,
  },

  data () {
    return {
      pickerResult: {
        employmentType: '',
        region: ''
      },
      employmentType: [
        {name: '受薪（一般上班族）', mark: '01'},
        {name: '自雇（营业执照客户）', mark: '02'},
      ]
    };
  },

  computed: {
    ...mapState(['freeLoanData']),
    employmentTypeColumns() {
      return this.returnColumns(this.employmentType)
    },
    yearsOfWorkColumns() {
      let year = new Date().getFullYear();
      let columns = [];
      for(let i = year; i > year - 100; i--) {
        columns.push(i)
      }
      return columns;
    }
  },

  created() {},

  methods: {
    getRegionPickerVal(val) {
      this.pickerResult.region = val[0].name + '/' + val[1].name + '/' + val[2].name
      this.freeLoanData.comP = val[0].code;
      this.freeLoanData.comC = val[1].code;
      this.freeLoanData.comA = val[2].code;
    },
    onPickerConfirm(type, val) {
      this.pickerResult[type] = val.value
      if(type === 'yearsOfWork') {
        this.freeLoanData[type] = val.value
      }else {
        this.freeLoanData[type] = this[type][val.index].mark
      }
    },
    showPicker(type) {
      this.$refs[type].show = true
    },
    returnColumns(objArr) {
      let columns = [];
      objArr.forEach(item => {
        columns.push(item.name)
      })
      return columns
    },
    nextStep() {
      let { pickerResult, freeLoanData } = this;
      if(!pickerResult.employmentType) {
        this.$toast("请选择雇佣类型")
        return;
      }
      if(!freeLoanData.comName) {
        this.$toast("请选择单位名称")
        return;
      }
      if(!freeLoanData.department) {
        this.$toast("请选择任职部门")
        return;
      }
      if(!freeLoanData.position) {
        this.$toast("请输入职务/职位")
        return;
      }
      if(!freeLoanData.yearsOfWork) {
        this.$toast("请选择入职时间")
        return;
      }
      if(!pickerResult.region) {
        this.$toast("请选择单位地址")
        return;
      }
      if(!freeLoanData.comAdd) {
        this.$toast("请输入详细地址")
        return;
      }
      if(!freeLoanData.comTel) {
        this.$toast("请输入单位电话")
        return;
      }
      let regx = /^(0\d{2,3}-)?\d{7,8}$/;
      if(!regx.test(freeLoanData.comTel)) {
        this.$toast('请输入正确的单位电话')
        return;
      }
      this.$store.dispatch('updateUserInfo').then(res => {
        this.$router.push("/free-loan/contact-info")
      })
    }
  },
}

</script>

<style lang='less' scoped>
  .lg-btn {
    margin-top: 26px;
  }
</style>